export default __webpack_public_path__ + "static/media/k_logo_svg.bba3913c.svg";